import React from "react"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import "./footer.scss"
import {
  MailIcon,
  MarkGithubIcon,
  GlobeIcon,
  MentionIcon,
  PeopleIcon,
} from "@primer/octicons-react"
import { graphql, useStaticQuery } from "gatsby"

const Footer = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          author
        }
      }
    }
  `)
  return (
    <footer className="blog-footer bg-dark text-light text-center">
      <Row className="mx-0">
        <Col className="footer-text text-center">
          <ul className="list-inline">
            <li className="list-inline-item">
              <a
                className="facebook"
                href="https://github.com/Sungharsh"
                target="_blank"
                rel="noreferrer"
              >
                <MarkGithubIcon size="medium" />
              </a>
            </li>
            <li className="list-inline-item">
              <a
                className="twitter"
                target="_blank"
                rel="noreferrer"
                href="https://sungharsh.github.io/"
              >
                <MailIcon size="medium" />
              </a>
            </li>
            <li className="list-inline-item">
              <a
                className="instagram"
                target="_blank"
                rel="noreferrer"
                href="https://sungharsh.github.io/"
              >
                <GlobeIcon size="medium" />
              </a>
            </li>
            <li className="list-inline-item">
              <a
                className="instagram"
                target="_blank"
                rel="noreferrer"
                href="https://sungharsh.github.io/"
              >
                <MentionIcon size="medium" />
              </a>
            </li>
            <li className="list-inline-item">
              <a
                className="instagram"
                target="_blank"
                rel="noreferrer"
                href="https://sungharsh.github.io/"
              >
                <PeopleIcon size="medium" />
              </a>
            </li>
          </ul>
          <hr className="mx-5 mt-0" style={{ background: "#f15842" }} />
          <p className="py-4">
            Copyright © 2020 {data.site.siteMetadata.author} &nbsp;
            {data.site.siteMetadata.title} All Right Reserved
          </p>
        </Col>
      </Row>
    </footer>
  )
}

export default Footer
